import React from "react";

import AdminLogin from '../../components/admin/AdminLogin'

import './adminloginpage.css'

const AdminLoginPage = () => {
  return (
    <div className='adminlogin'>
      <AdminLogin />
    </div>
  )
}

export default AdminLoginPage